import { render, staticRenderFns } from "./ProposalReview.vue?vue&type=template&id=03a5a079&"
import script from "./ProposalReview.vue?vue&type=script&lang=js&"
export * from "./ProposalReview.vue?vue&type=script&lang=js&"
import style0 from "./ProposalReview.vue?vue&type=style&index=0&id=03a5a079&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports